import { createFileRoute } from '@tanstack/react-router'
import { AlternativesPage, alternativesHead, type AlternativesData } from '@/components/alternatives-page'
import { MONITOR_LOCATIONS } from '@/lib/check-locations'

const data: AlternativesData = {
  tool: "Cronitor",
  slug: "cronitor",
  intro: "Cronitor bills cron and uptime monitoring per monitor and per user. If you want flat pricing or a different approach to job monitoring, these alternatives are worth evaluating.",
  alternatives: [
    {
      name: "Healthchecks.io",
      description: "Open-source cron job monitoring, also self-hostable, with a free plan of 20 checks.",
      pricing: "Free (20 checks), Supporter $5/mo, Business $20/mo",
      pros: ["Open source and self-hostable", "Unlimited team members on all plans", "Focused on cron and heartbeat jobs"],
      cons: ["No HTTP uptime checks", "Status badges only, no hosted status pages"],
      url: "https://healthchecks.io",
    },
    {
      name: "Uptrack",
      description: "Cron, heartbeat, and uptime monitors share one flat plan, with 30-second checks and alert confirmation. Pro is $3/mo for 50 monitors.",
      pricing: "Free (5 monitors), Pro $3/mo, Team $20/mo, Business $79/mo",
      pros: ["30-second checks on every plan", "Alerts only after 2-5 consecutive failed checks", "Flat pricing with a 30-day money-back guarantee"],
      cons: ["Free plan is 5 monitors at 30 s from one location", MONITOR_LOCATIONS.alternativesCon, "No APM or logs"],
      url: "https://uptrack.app",
      isUptrack: true,
    },
    {
      name: "Better Stack",
      description: "Uptime monitoring combined with on-call, incident management, logs, and status pages in one platform.",
      pricing: "Free (10 monitors), paid from $34/mo per responder",
      pros: ["On-call scheduling and incident management", "Unlimited phone and SMS alerts on paid plans", "Multi-location confirmation (3 of 4 locations by default)"],
      cons: ["Priced per responder, plus monitor packs", "More product than you need if you only want uptime checks"],
      url: "https://betterstack.com",
    },
    {
      name: "Oh Dear",
      description: "Site health monitoring: uptime, SSL, DNS, broken links, mixed content, Lighthouse, cron, and status pages.",
      pricing: "From $17/mo (2 sites), 10-day trial",
      pros: ["Broken link and mixed content checks", "Application health checks for Laravel/PHP apps", "Unlimited users on all plans"],
      cons: ["No free plan", "1-minute check interval"],
      url: "https://ohdear.app",
    },
    {
      name: "PagerDuty",
      description: "Incident management with on-call scheduling and escalation, fed by your monitoring tools.",
      pricing: "Free plan for small teams; paid plans priced per user",
      pros: ["On-call scheduling and escalation policies", "Large integration catalog"],
      cons: ["Priced per user", "No built-in uptime checks; relies on integrations"],
      url: "https://www.pagerduty.com",
    },
  ],
  comparisonTable: [
    { tool: "Healthchecks.io", freePlan: "20 checks", checkInterval: "Heartbeat", alertConfirmation: "Grace period", startingPrice: "$5/mo" },
    { tool: "Uptrack", freePlan: "5 monitors at 30s", checkInterval: "30s (all plans)", alertConfirmation: "Yes (2-5 consecutive)", startingPrice: "Free; Pro $3/mo" },
    { tool: "Better Stack", freePlan: "10 monitors", checkInterval: "3min (free), 30s (paid)", alertConfirmation: "Yes (multi-location)", startingPrice: "$34/mo per responder" },
    { tool: "Oh Dear", freePlan: "None", checkInterval: "1min", alertConfirmation: "Yes (second location)", startingPrice: "$17/mo" },
    { tool: "PagerDuty", freePlan: "Small teams", checkInterval: "Via integrations", alertConfirmation: "Configurable", startingPrice: "Per user" },
  ],
}

export const Route = createFileRoute('/_site/alternatives/cronitor')({
  component: () => <AlternativesPage data={data} />,
  head: () => alternativesHead(data),
})
